// ProductStockDialog.js
import React, { useState, useRef, useEffect } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Resize,
  Selection,
  Edit,
  Toolbar,
  Inject,
  Aggregate
} from '@syncfusion/ej2-react-grids';
import { AutoComplete } from '@syncfusion/ej2-dropdowns';
import invoiceService from './invoice.service';
import dropdownService from '../software-dynamic-version-5/api.service-v-5';
import './invoice.scss';
import securityService from '../security/security.service';
import moment from  'moment'
import saleInvoiceService from '../sale-invoice/sale-invoice.service';
import { SidebarComponent } from '@syncfusion/ej2-react-navigations';

import {
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  StructuredGenerate,
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';
 
import { SaveOutlined, CloseOutlined } from '@material-ui/icons';
// ─── keyframe injection (once) ───────────────────────────────
if (typeof document !== 'undefined' && !document.getElementById('stock-spin-style')) {
  const s = document.createElement('style');
  s.id = 'stock-spin-style';
  s.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
}

const GRID_ID = 'ProductStockGrid';

const ProductStockDialog = ({ visible, onClose, onDataLoaded, InvoiceType ,InvoiceDate}) => {

  const updateMainSecionsValue = (valueObj) => {
    
      setFilterInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = { ...updatedValues[key], ...valueObj[key] };
        }
      });
      return updatedValues;
      
    });
  }
  const [filterInputProps, setFilterInputProps] = useState({
    GDNo: {
      name: { id: 'GDID', value: 'GDNo' },
      caption: 'GD',
      value: { id: null, value: '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },
  
    ProductName: {
      name: { id: 'ProductName', value: 'ProductName' },
      caption: 'Product',
      value: { id: null, value: '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },
  
    DescriptionCode: {
      name: { id: 'hS_CODE', value: 'DescriptionCode' },
      caption: 'HS Code',
      value: { id: null, value: '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },
  
    Filter: {
      name: 'Filter',
      caption: 'Filter',
      enabled:true
    },
  
    Cancel: {
      name: 'Cancel',
      caption: 'Clear',
      enabled:true
    }
  });
  const [originalStockDS, setOriginalStockDS] = useState([]);

  const [filters, setFilters] = useState({
    GDID: null,
    ProductName: null,
    hS_CODE: null
  });
  
  const [filterDD, setFilterDD] = useState({
    gd: [],
    product: [],
    hs: []
  });
  const [stockDS,  setStockDS]  = useState([]);
  const [loading,  setLoading]  = useState(false);
  const grid = useRef(null);
  const currentPage = useRef(1);
  
 
    // ── same pattern as invoice-add: plain object (not state) so no re-render
  const autoCompleteInstances = useRef({}).current;

  // ─── Load stock when dialog opens ───────────────────────────
  useEffect(() => {
    if (visible) loadStock();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const loadStock = async (type = 'normalFetching', filterParams = {}) => {
  setLoading(true);
  try {
    setTimeout(() => {
      updateMainSecionsValue({ 
        Filter: { enabled: true },
        Cancel: { enabled: true },
      });
    }, 1000);
    const defaultParams = {
      FromDate: '01-JAN-24',
      ToDate:  InvoiceDate ?  moment(InvoiceDate).format('DD-MMM-YY') :  moment().format('DD-MMM-YY'),
      GDID:     0,
      ProductID: 0,
      HS_Code:  ''
    };

    console.log(defaultParams)

    const params = { ...defaultParams, ...filterParams };
      console.log(params)
    const res  = await invoiceService.getProductStock(params);
    console.log(res)
    const rows = (res?.data?.recordset || res?.data || []);

    const mapped = rows.map((r, i) => ({
      ...r,
      IndexID:                  i + 1,
      DescriptionCode:          r.DescriptionCode  || r.hS_CODE || '',
      ProductDescription:       r.ProductDescription || r.ProductName || '-',
      Quantity:                 0,
      FBRQuantity:              0,
      Rate:                     r.Rate             ?? 0,
      BillAmount:               0,
      TaxPercent:               r.TaxPercent || null,
      TaxPercentValue:          r.TaxPercentValue   || '',
      TaxAmount:                0,
      TotalAmount:              0,
      FBRUnitOfMeasurement:     r.FBRUnitOfMeasurement   || '',
      FBRUnitOfMeasurementID:   r.FBRUnitOfMeasurementID || null,
      SpecialExciseDutyPercent: 0,
      SpecialExciseDutyAmount:  0,
      DiscountPercent:          0,
      DiscountAmount:           0,
    }));

    setStockDS(mapped);
    setOriginalStockDS(mapped);

    const uniqueBy = (arr, keyId, keyValue) => {
      const map = new Map();
      arr.forEach(item => {
        if (!map.has(item[keyId]) && item[keyId] !== null && item[keyId] !== undefined) {
          map.set(item[keyId], { id: item[keyId], value: item[keyValue] });
        }
      });
      return Array.from(map.values());
    };

    setFilterInputProps(prev => ({
      ...prev,
      GDNo: {
        ...prev.GDNo,
        dataSource: { type: 'Data', data: uniqueBy(mapped, 'GDID', 'GDNo') }
      },
      ProductName: {
        ...prev.ProductName,
        dataSource: { type: 'Data', data: uniqueBy(mapped, 'ProductID', 'ProductName') }
      },
      DescriptionCode: {
        ...prev.DescriptionCode,
        dataSource: { type: 'Data', data: uniqueBy(mapped, 'hS_CODE', 'DescriptionCode') }
      }
    }));
  } catch (e) {
    console.error('ProductStock load error:', e);
  }
  setLoading(false);
};


  const handleFilterChange = (value, name) => {
    setFilterInputProps(prev => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: value
      }
    }));
  };
const applyFilter = (name) => {
  console.log(name)
  if (name == 'Filter') {
    console.log(filterInputProps)
    const gdid      = filterInputProps.GDNo.value?.id        || 0;
    const productId = filterInputProps.ProductName.value?.id || 0;
    const hsCode    = filterInputProps.DescriptionCode?.value?.value      || '';

    const filterParams = {
      GDID:      gdid,
      ProductID: productId,
      HS_Code:   hsCode
    };

    loadStock('normalFetching', filterParams);

    
  }
};
const clearFilter = (name) => {
  if(name == 'Cancel'){
  setFilterInputProps(prev => ({
    ...prev,
    GDNo:        { ...prev.GDNo,        value: { id: null, value: '' } },
    ProductName: { ...prev.ProductName, value: { id: null, value: '' } },
    DescriptionCode:      { ...prev.DescriptionCode,      value: { id: null, value: '' } }
  }));

  loadStock('normalFetching', {
    FromDate:   '01-JAN-24',
    ToDate:  InvoiceDate ?  moment(InvoiceDate).format('DD-MMM-YY') :  moment().format('DD-MMM-YY'),
    GDID:      0,
    ProductID: 0,
    HS_Code:   ''
  });

  }
};

  // ─── Dropdown data loader — identical to invoice-add ────────
  const showToast = (msg, type = 'error') => {
    const toast = document.createElement('div');
    toast.innerText = msg;
  
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      background: type === 'error' ? '#DC2626' : '#16A34A',
      color: '#fff',
      padding: '10px 16px',
      borderRadius: '6px',
      fontSize: '12px',
      zIndex: 999999
    });
  
    document.body.appendChild(toast);
  
    setTimeout(() => toast.remove(), 3000);
  };
  const getDataSource = async (routeKey, obj,args) => {
    try {
      console.log(args);
      switch (routeKey) {
        case "FBRUOMPRODUCTSTOCK": {
          const CompanyID = securityService.getCompanyIDLoggedInUserId();
      const data = {
        CompanyID,
        hs_code: args.rowData.DescriptionCode || args.rowData.hS_CODE,
        annexure_id: 3
      };

      if (data.hs_code) {
        const response = await saleInvoiceService.getUOMDDSource(data);
        console.log(response?.data)
        if (response?.data) {
          const uoMDataSource = response.data.map((row) => ({
            id: row.uoM_ID,
            value: row.description
          }));
          obj.dataSource = uoMDataSource
          }else{
            obj.dataSource = []
          }
        }
          break;
        }

        case "TaxPercentDDSource": {
          const CompanyID = securityService.getCompanyIDLoggedInUserId();
          let data = {
            CompanyID,
          date: moment().format('DD-MMM-YY'),
          transTypeId:75,
          originationSupplier:8
        }
        console.log(data)
        if(data.transTypeId && data.CompanyID && data.originationSupplier){
          let response = await saleInvoiceService.getRateDDSource(data);
          if(response){
            console.log(response);
            let rateDataSource = response.data.map((row)=> { return {id:row.ratE_VALUE ,value:row.ratE_DESC,...row}});
            console.log(rateDataSource)
            obj.dataSource = rateDataSource
          }else{
            obj.dataSource = []
          }
        }
          break;
        
        
      }
        case "ItemDescriptionSource": 
         const response1 = await dropdownService.getAllForList(routeKey);
          obj.dataSource = response1?.data?.recordset || [];
        //{ // Example for future
        //   const companyID = securityService.getCompanyIDLoggedInUserId();
        //   const res = await saleInvoiceService.getItems(companyID);
        //   obj.dataSource = (res?.data || []).map(r => ({
        //     value: r.itemCode,
        //     text: r.itemName
        //   }));
        //   break;
        // }
        
        default:
          // Default dropdown service
          const response = await dropdownService.getAllForList(routeKey);
          obj.dataSource = response?.data?.recordset || [];
      }
    } catch (error) {
      console.error(`Error loading ${routeKey}:`, error);
      obj.dataSource = [];
      showToast(`Failed to load ${routeKey}`);

    }
  };


  // ─── AutoComplete factory — 1:1 from invoice-add ─────────────
  const createAutoComplete = (params) => {
    let elem;
    const dynamicKey = `obj_${params.field.id}`;

    const create  = () => { elem = document.createElement('input'); return elem; };
    const destroy = () => autoCompleteInstances[dynamicKey]?.destroy();
    const read    = () => autoCompleteInstances[dynamicKey]?.text;

    const write = async (args) => {
      autoCompleteInstances[dynamicKey] = new AutoComplete({
        value:           args.rowData[params.field.value],
        fields:          { value: 'value' },
        placeholder:     `Select ${params.caption}`,
        highlight:       true,
        showClearButton: false,

        created: async () => {
          // 1. Load source
          if (params?.source?.type === 'Route') {
            await getDataSource(params.source.dataSource, autoCompleteInstances[dynamicKey],args);
          } else if (params?.source?.type === 'Data') {
            autoCompleteInstances[dynamicKey].dataSource = params?.source?.dataSource || [];
          }

          // Seed existing dropdown value
          if (args.requestType === 'beginEdit') {
            autoCompleteInstances[dynamicKey].dropdownValues = {
              id:    args.rowData[params.field.id],
              value: args.rowData[params.field.value],
              ...args.rowData
            };
          }

          // FBR UOM — resolve ID from value when ID missing
          if (params.field.id === 'FBRUnitOfMeasurementID') {
            const src = Array.isArray(autoCompleteInstances[dynamicKey].dataSource)
              ? autoCompleteInstances[dynamicKey].dataSource : [];
            const val = args.rowData.FBRUnitOfMeasurement;
            if (val && !args.rowData.FBRUnitOfMeasurementID) {
              const match = src.find(s => s.value?.toLowerCase() === val?.toLowerCase());
              if (match) {
                args.rowData.FBRUnitOfMeasurementID = match.id;
                autoCompleteInstances[dynamicKey].dropdownValues = { id: match.id, value: match.value };
              }
            }
          }

          // TaxPercent — resolve ID from value
          if (params.field.id === 'TaxPercent') {
            const src = Array.isArray(autoCompleteInstances[dynamicKey].dataSource)
              ? autoCompleteInstances[dynamicKey].dataSource : [];
            const val = String(args.rowData.TaxPercentValue);
            if (val) {
              const match = src.find(s => s.value?.toLowerCase() === val.toLowerCase())
                || src.find(s => String(s.id) === val);
              if (match) {
                args.rowData.TaxPercent      = match.id;
                args.rowData.TaxPercentValue = match.value;
                autoCompleteInstances[dynamicKey].value          = match.value;
                autoCompleteInstances[dynamicKey].dropdownValues = { id: match.id, value: match.value };
              }
            }
            
          }
        },

        // focus: () => {
        //   if (autoCompleteInstances[dynamicKey]) autoCompleteInstances[dynamicKey].showPopup();
        // },
        focus: () => {
          setTimeout(() => {
            autoCompleteInstances[dynamicKey]?.showPopup();
          }, 100);
        },

        select: (e) => {
          autoCompleteInstances[dynamicKey].dropdownValues = {
            id: e.itemData?.id, value: e.itemData?.value, ...e.itemData
          };
          if (params.field.id) args.rowData[params.field.id] = e.itemData.id;
          args.rowData[params.field.value] = e.itemData.value;

          // Bug 2 fix — runtime recalc when Tax% dropdown changes
          if (params.field.id === 'TaxPercent') {
            
            recalcForm1(args);
          }
        },

        // change: (e) => {
        //   autoCompleteInstances[dynamicKey].dropdownValues = {
        //     id: e?.itemData?.id, value: e?.itemData?.value, ...e?.itemData
        //   };
        //   const ds      = Array.isArray(autoCompleteInstances[dynamicKey].dataSource)
        //     ? autoCompleteInstances[dynamicKey].dataSource : [];
        //   const isValid = ds.some(s => s.value === e.value);
        //   if (!isValid) {
        //     if (params.field.id) args.rowData[params.field.id] = undefined;
        //     args.rowData[params.field.value] = e?.value;
        //   } else {
        //     const sel = ds.find(s => s.value === e.value);
        //     if (params.field.id) args.rowData[params.field.id] = sel.id;
        //     args.rowData[params.field.value] = sel.value;
        //   }
        // }

        change: (e) => {
          const ds = Array.isArray(autoCompleteInstances[dynamicKey].dataSource)
            ? autoCompleteInstances[dynamicKey].dataSource
            : [];
        
          const match = ds.find(s => s.value === e.value);
        
          if (!match) {
            // ❌ reset invalid entry
            autoCompleteInstances[dynamicKey].value = '';
            autoCompleteInstances[dynamicKey].dropdownValues = {};
        
            if (params.field.id) args.rowData[params.field.id] = null;
            args.rowData[params.field.value] = '';
        
            showToast("Please select a valid value");
          } else {
            autoCompleteInstances[dynamicKey].dropdownValues = match;
        
            if (params.field.id) args.rowData[params.field.id] = match.id;
            args.rowData[params.field.value] = match.value;
          }
        }
      });

      autoCompleteInstances[dynamicKey].appendTo(elem);
    };

    return { create, destroy, read, write };
  };
  const recalcForm1 = (args) => {
    console.log(args);
    const toN = (id) => {
      const el = document.getElementById(`${GRID_ID}${id}`);
      return parseFloat(el?.value?.replace(/,/g, '') ?? '0') || 0;
    };

    const qty    = toN('Quantity');
    const rate   = toN('Rate');

    // ── FIX 1: taxPer now reliably from dropdownValues (seeded above) ──
    const taxPer = parseFloat(
      autoCompleteInstances['obj_TaxPercent']?.dropdownValues?.id
      ?? toN('TaxPercent')
    ) || 0;

    console.log(taxPer);
    const bill   = parseFloat((qty * rate).toFixed(2));
    console.log(bill);
    const taxAmt = parseFloat((bill * (taxPer / 100)).toFixed(2));
    console.log(taxAmt);
    const total  = parseFloat((bill + taxAmt).toFixed(2));
    console.log(total);

    if (args.element.form[`${GRID_ID}FBRQuantity`]?.ej2_instances?.[0])
      args.element.form[`${GRID_ID}FBRQuantity`].ej2_instances[0].value = qty;

    if (args.element.form[`${GRID_ID}BillAmount`]?.ej2_instances?.[0])
      args.element.form[`${GRID_ID}BillAmount`].ej2_instances[0].value = bill;

    if (args.element.form[`${GRID_ID}TaxAmount`]?.ej2_instances?.[0])
      args.element.form[`${GRID_ID}TaxAmount`].ej2_instances[0].value = taxAmt;

    if (args.element.form[`${GRID_ID}TotalAmount`]?.ej2_instances?.[0])
      args.element.form[`${GRID_ID}TotalAmount`].ej2_instances[0].value = total;
  };
  // ─── Bug 2 fix: runtime calc — reads live form inputs ────────
  // Same as invoice-add's calc() but with GRID_ID prefix
  const recalcForm = (form) => {
    console.log(form)
    const toN = (id) => {
      const el = document.getElementById(`${GRID_ID}${id}`);
      return parseFloat(el?.value?.replace(/,/g, '') ?? '0') || 0;
    };

    const qty    = toN('Quantity');
    const rate   = toN('Rate');
    // TaxPercent comes from AutoComplete id, not input value
    const taxPer = parseFloat(
      autoCompleteInstances['obj_TaxPercent']?.dropdownValues?.id
      ?? toN('TaxPercent')
    ) || 0;
console.log(taxPer)
    const bill   = parseFloat((qty * rate).toFixed(2));
    console.log(bill)
    const taxAmt = parseFloat((bill * (taxPer / 100)).toFixed(2));
    console.log(taxAmt)
    const total  = parseFloat((bill + taxAmt).toFixed(2));
    console.log(total)

    if (form?.elements[`${GRID_ID}FBRQuantity`]?.ej2_instances?.[0])
      form.elements[`${GRID_ID}FBRQuantity`].ej2_instances[0].value = qty;


    if (form?.elements[`${GRID_ID}BillAmount`]?.ej2_instances?.[0])
      form.elements[`${GRID_ID}BillAmount`].ej2_instances[0].value = bill;

    if (form?.elements[`${GRID_ID}TaxAmount`]?.ej2_instances?.[0])
      form.elements[`${GRID_ID}TaxAmount`].ej2_instances[0].value = taxAmt;

    if (form?.elements[`${GRID_ID}TotalAmount`]?.ej2_instances?.[0])
      form.elements[`${GRID_ID}TotalAmount`].ej2_instances[0].value = total;
  };

  // ─── tooltip helper (Bug 4) ───────────────────────────────────
  const showQtyTooltip = (el, msg) => {
    const existing = document.getElementById('stock-qty-tooltip');
    if (existing) existing.remove();
  
    const tip = document.createElement('div');
    tip.id = 'stock-qty-tooltip';
    tip.innerText = msg;
  
    Object.assign(tip.style, {
      position: 'absolute',
      background: '#B91C1C',
      color: '#fff',
      fontSize: '11px',
      fontWeight: '600',
      padding: '4px 10px',
      borderRadius: '4px',
      zIndex: '999999',
      whiteSpace: 'nowrap'
    });
  
    document.body.appendChild(tip);
  
    const rect = el.getBoundingClientRect();
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
  
    tip.style.left = `${rect.left + window.scrollX}px`;
    tip.style.top  = `${rect.top + scrollTop - 35}px`;
  
    setTimeout(() => tip.remove(), 2500);
  };

  // ─── actionComplete — full invoice-add pattern ───────────────
  const actionComplete = (args) => {
console.log(args)
    /* ══ beginEdit / add — attach runtime events (Bug 2 + 4 + 5) ══ */
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {

      // runtime recalc on Quantity and Rate change
      ['Quantity', 'Rate'].forEach((f) => {
        const el = document.getElementById(`${GRID_ID}${f}`);
        if (el) {
          ['input', 'keyup', 'keydown'].forEach(ev =>
            el.addEventListener(ev, () => recalcForm(args.form))
          );
        }
      });

      // Bug 4 — blur on Quantity: validate against StockQuantity
      const qtyEl = document.getElementById(`${GRID_ID}Quantity`);
      if (qtyEl) {
        qtyEl.addEventListener('blur', () => {
          const enteredQty = parseFloat(qtyEl.value?.replace(/,/g, '') || '0');
          const stockQty   = parseFloat(args.rowData?.StockQuantity ?? 0);
          if (enteredQty > stockQty) {
            showQtyTooltip(qtyEl, `Sale Qty (${enteredQty}) cannot exceed Stock Qty (${stockQty})`);
            // reset to stock qty silently — no auto-focus
            if (qtyEl.ej2_instances?.[0]) {
              qtyEl.ej2_instances[0].value = stockQty;
            } else {
              qtyEl.value = stockQty;
            }
            recalcForm(args.form);
          }
        });
      }

      // Bug 5 — Tab on TotalAmount → endEdit → next row (invoice-add pattern)
      const totalEl = document.getElementById(`${GRID_ID}TotalAmount`);
      if (totalEl) {
        totalEl.addEventListener('keydown', (e) => {
          e.stopPropagation();
          if (e.key === 'Tab') {
            setTimeout(() => {
              grid.current?.endEdit();

              // move to next row
              setTimeout(() => {
                const currentViewData = grid.current?.currentViewData || [];
                const nextRow = (args.rowIndex ?? 0) + 1;
                if (nextRow < currentViewData.length) {
                  grid.current?.selectRow(nextRow);
                  grid.current?.startEdit();
                }
              }, 600);
            }, 200);
          }
        });
      }
    }

   
    /* ══ SAVE — sync AutoComplete IDs + recalc into state ══ */
    if (args.requestType === 'save') {
      const toN = (v) => parseFloat(String(v ?? '0').replace(/,/g, '')) || 0;

      const qty    = toN(args.data.Quantity);
      const rate   = toN(args.data.Rate);
      const taxPer = parseFloat(
        autoCompleteInstances['obj_TaxPercent']?.dropdownValues?.id ?? args.data.TaxPercent 
      ) || 0;

      const bill   = parseFloat((qty * rate).toFixed(2));
      const taxAmt = parseFloat((bill * (taxPer / 100)).toFixed(2));
      const total  = parseFloat((bill + taxAmt).toFixed(2));

      setStockDS(prev =>
        prev.map(r => {
          if (r.IndexID !== args.data.IndexID) return r;
          return {
            ...r,
            ...args.data,
            BillAmount:               bill,
            TaxAmount:                taxAmt,
            TotalAmount:              total,
            TaxPercent:               autoCompleteInstances['obj_TaxPercent']?.dropdownValues?.id    ?? taxPer,
            TaxPercentValue:          autoCompleteInstances['obj_TaxPercent']?.dropdownValues?.value ?? String(taxPer),
            FBRUnitOfMeasurementID:   autoCompleteInstances['obj_FBRUnitOfMeasurementID']?.dropdownValues?.id    ?? r.FBRUnitOfMeasurementID,
            FBRUnitOfMeasurement:     autoCompleteInstances['obj_FBRUnitOfMeasurementID']?.dropdownValues?.value ?? r.FBRUnitOfMeasurement,
            SpecialExciseDutyPercent: 0,
            SpecialExciseDutyAmount:  0,
            DiscountPercent:          0,
            DiscountAmount:           0,
          };
        })
      );
    }
    
    
  };

  // ─── actionBegin — block add/delete ─────────────────────────
  // const actionBegin = (args) => {
  //   const updatedData = grid.current?.dataSource || [];
  //   console.log("FINAL DATA:", updatedData);
  //   if (args.requestType === 'add' || args.requestType === 'delete') {
  //     args.cancel = true;
  //   }
  // };

  const actionBegin = (args) => {
    if (args.requestType === 'save') {
  
      const tax = autoCompleteInstances['obj_TaxPercent']?.dropdownValues;
      const uom = autoCompleteInstances['obj_FBRUnitOfMeasurementID']?.dropdownValues;
  
      if (!tax?.id || !uom?.id) {
        args.cancel = true;
  
        showToast("Please select Tax % and FBR UOM from dropdown");
  
        return;
      }
    }
  
    if (args.requestType === 'add' || args.requestType === 'delete') {
      args.cancel = true;
    }
  };
  // ─── Grid config — same as invoice-add ──────────────────────
  const gridConfig = {
    height:           '100%',
    width:            '100%',
    rowHeight:        25,
    gridLines:        'Horizontal',
    allowTextWrap:    true,
    textWrapSettings: { wrapMode: 'Both' },
    clipMode:         'Clip',
    allowPaging:      true,
    allowSorting:     true,
    allowResizing:    true,
    allowSelection:   true,
    allowFiltering:   true,
    filterSettings:  {
      type: 'Excel',
      // columns: [
      //   {
      //     field: 'IsDeleted',
      //     operator: 'notequal',
      //     value: 'True'
      //   }
      // ]
      columns: []
  
    },
    pageSettings:     { pageSize: stockDS.length, pageSizes: [ stockDS.length, 'All'] },
    selectionSettings: { type: 'Single', mode: 'Row' },
    editSettings: {
      allowAdding:             false,
      allowEditing:            true,
      allowDeleting:           false,
      mode:                    'Normal',
      showDeleteConfirmDialog: false,
    },
    toolbar: ['Edit', 'Update', 'Cancel'],
    
    aggregates: [
      {
        columns: [
          {
            type: 'Sum', field: 'Quantity', format: 'n2',
            footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span>
          },
          {
            type: 'Sum', field: 'FBRQuantity', format: 'n2',
            footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span>
          },
          {
            type: 'Sum', field: 'BillAmount', format: 'n2',
            footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span>
          },
          {
            type: 'Sum', field: 'TaxAmount', format: 'n2',
            footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span>
          },
          {
            type: 'Sum', field: 'TotalAmount', format: 'n2',
            footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span>
          }
        ]
      }
    ]
  };

  // ─── Close: push data to parent ─────────────────────────────
  const handleClose = () => {
    if (onDataLoaded) onDataLoaded(stockDS);
    onClose();
  };

  if (!visible) return null;





  
 
  // ── 6. Open sidebar ──────────────────────────────────────────────────────

  const filterInputs = [
    {
      Input: DynamicDropDownInput,
      Props: { ...filterInputProps.GDNo, setInputProps: setFilterInputProps, onChange: handleFilterChange },
      ColumnSize: 3
    },
    {
      Input: DynamicDropDownInput,
      Props: { ...filterInputProps.ProductName, setInputProps: setFilterInputProps, onChange: handleFilterChange },
      ColumnSize: 3
    },
    {
      Input: DynamicDropDownInput,
      Props: { ...filterInputProps.DescriptionCode, setInputProps: setFilterInputProps, onChange: handleFilterChange },
      ColumnSize: 3
    },
    {
      Input: DynamicButtonInput,
      Props: {
        ...filterInputProps.Filter,setInputProps: setFilterInputProps,
        onClick: applyFilter
      },
      ColumnSize: 1
    },
   
    
    {
      Input: DynamicButtonInput,
      Props: {
        ...filterInputProps.Cancel,setInputProps: setFilterInputProps,
        onClick: clearFilter
      },
      ColumnSize: 1
    }
  ];
 
  return (
    <div style={S.overlay}>
      <div style={S.modal}>

        {/* ══ Bug 1: Centered heading, no icon, green X top-right ══ */}
        <div style={S.header}>
          {/* invisible spacer to center the title */}
          <div style={{ width: 32 }} />
          <h1 style={S.title}>PRODUCT STOCK</h1>
          <button style={S.closeBtn} onClick={handleClose} title="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* ══ Body — grid fills space, footer is absolute ══ */}
        <div style={S.body}>
          {loading ? (
            <div style={S.loadingBox}>
              <div style={S.spinner} />
              <span style={S.loadingText}>LOADING STOCK DATA...</span>
            </div>
          ) : (
            <div style={S.gridWrapper}>

              {/* info bar */}
              <div style={S.infoBar}>
                <span style={S.infoText}>
                  Edit rows inline — Sale Qty, FBR Qty, Rate, FBR UOM, Tax % are editable.
                </span>
                <span style={S.rowBadge}>{stockDS.length} Rows</span>
              </div>


              <StructuredGenerate
                    mainProps={{}}
                    title={''}
                    Inputs={filterInputs}
                  />

            {/* grid */}
              <div style={S.gridContainer}>
                <GridComponent
                  id={GRID_ID}
                  ref={grid}
                  dataSource={stockDS}
                  {...gridConfig}
                  actionBegin={actionBegin}
                  actionComplete={actionComplete}
                  toolbarClick={(args)=>{
                    const itemId = args?.item?.id;
    
                    // detect filter button
                   
                  }}
                  dataBound={() => {
                    if (grid.current) {
                      currentPage.current = grid.current.pageSettings.currentPage;
                    }
                  }}
                >
                  <ColumnsDirective>

                    {/* ── Hidden ID fields ── */}
                    <ColumnDirective field="IndexID"                  isPrimaryKey width="60"  visible={false} />
                    <ColumnDirective field="hS_CODE"                  width="80"   visible={false} />
                    <ColumnDirective field="GDID"                     width="80"   visible={false} />
                    <ColumnDirective field="ProductID"                width="80"   visible={false} />
                    <ColumnDirective field="TaxPercent"                width="80"   visible={false} />
                    <ColumnDirective field="UnitOfMeasurementID"      width="80"   visible={false} />
                    <ColumnDirective field="FBRUnitOfMeasurementID"   width="80"   visible={false} />
                    <ColumnDirective field="SpecialExciseDutyPercent" width="80"   visible={false} />
                    <ColumnDirective field="SpecialExciseDutyAmount"  width="80"   visible={false} />
                    <ColumnDirective field="DiscountPercent"          width="80"   visible={false} />
                    <ColumnDirective field="DiscountAmount"           width="80"   visible={false} />

                    {/* ── Disabled read-only columns ── */}
                    <ColumnDirective
                      field="DescriptionCode"  headerText="HS Code"
                      width="110" headerTextAlign="center" allowEditing={false}
                    />
                    <ColumnDirective
                      field="GDNo"             headerText="GD No"
                      width="110" headerTextAlign="center" allowEditing={false}
                    />
                    <ColumnDirective
                      field="ProductName"      headerText="Product"
                      width="140" headerTextAlign="center" allowEditing={false}
                    />

                    {/* ── Editable: Description ── */}
                    <ColumnDirective
                      field="ProductDescription" headerText="Description"
                      width="150" headerTextAlign="center"
                    />

                    {/* ── Disabled: Stock Quantity ── */}
                    <ColumnDirective
                      field="StockQuantity"  headerText="Stock Qty"
                      width="100" textAlign="right" headerTextAlign="center"
                      format="n2" allowEditing={false}
                      editType="numericedit"
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />

                    {/* ── Editable numerics ── */}
                    <ColumnDirective
                      field="Quantity"      headerText="Sale Qty"
                      width="100" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit"
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />
                    <ColumnDirective
                      field="FBRQuantity"   headerText="FBR Qty"
                      width="100" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit"
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />
                    <ColumnDirective
                      field="Rate"          headerText="Sale Rate"
                      width="100" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit"
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />

                    {/* ── Disabled: UOM ── */}
                    <ColumnDirective
                      field="UnitOfMeasurement" headerText="UOM"
                      width="100" headerTextAlign="center" allowEditing={false}
                    />

                    {/* ── FBR UOM dropdown ── */}
                    <ColumnDirective
                      field="FBRUnitOfMeasurement" headerText="FBR UOM"
                      width="120" editType="dropdownedit" headerTextAlign="center"
                      edit={createAutoComplete({
                        field:   { id: 'FBRUnitOfMeasurementID', value: 'FBRUnitOfMeasurement' },
                        caption: 'FBR Unit Of Measurement',
                        source:  { type: 'Route', dataSource: 'FBRUOMPRODUCTSTOCK' }
                      })}
                    />

                    {/* ── Tax Percent dropdown ── */}
                    <ColumnDirective
                      field="TaxPercentValue" headerText="Tax %"
                      width="110" editType="dropdownedit" headerTextAlign="center"
                      edit={createAutoComplete({
                        field:   { id: 'TaxPercent', value: 'TaxPercentValue' },
                        caption: 'Tax Percent',
                        source:  { type: 'Route', dataSource: 'TaxPercentDDSource' }
                      })}
                    />

                    {/* ── Calculated (editable override) ── */}
                    <ColumnDirective
                      field="BillAmount"  headerText="Bill Amt"
                      width="120" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit" allowEditing={true}
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />
                    <ColumnDirective
                      field="TaxAmount"   headerText="Tax Amt"
                      width="120" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit" allowEditing={true}
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />
                    <ColumnDirective
                      field="TotalAmount" headerText="Total"
                      width="120" textAlign="right" headerTextAlign="center"
                      format="n2" editType="numericedit" allowEditing={true}
                      edit={{ params: { cssClass: 'num-right', format: 'n2' } }}
                    />
                  </ColumnsDirective>

                  <Inject services={[Page, Sort, Resize, Selection, Edit, Toolbar, Aggregate]} />
                </GridComponent>
              </div>

              {/* Bug 1 fix — footer fixed at absolute bottom, LOAD button centered */}
              <div style={S.footer}>
                <button style={S.loadBtn} onClick={handleClose}>
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  LOAD TO INVOICE
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   STYLES
══════════════════════════════════════════════════════════════ */
const S = {
  overlay: {
    position:       'fixed',
    inset:          0,
    background:     'rgba(0,0,0,0.50)',
    zIndex:         99999,
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
  },
  modal: {
    background:     '#fff',
    // borderRadius:   10,
    width:          '96vw',
    maxWidth:       '1520px',
    height:         '90vh',            // fixed height so footer can be absolute
    display:        'flex',
    flexDirection:  'column',
    boxShadow:      '0 8px 40px rgba(0,0,0,0.22)',
    fontFamily:     "'Inter','Segoe UI',sans-serif",
    overflow:       'hidden',
    position:       'relative',
  },

  /* Bug 1 — centered heading, green X */
  header: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-between',
    padding:        '6px 14px',
    borderBottom:   '1px solid #E2E8F0',
    flexShrink:     0,
    background:     '#fff',
  },
  title: {
    padding:        '4px',
    margin:         0,
    fontSize:       16,
    fontWeight:     700,
    color:          '#0F172A',
    textTransform:  'uppercase',
    letterSpacing:  0.5,
    textAlign:      'center',
    flex:           1,
  },
  closeBtn: {
    width:          32,
    height:         32,
    // borderRadius:   6,
    // background:     '#16A34A',
    color:  '#16A34A ',
    border:         'none',
    cursor:         'pointer',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    flexShrink:     0,
  },

  /* Body */
  body: {
    flex:           1,
    display:        'flex',
    flexDirection:  'column',
    overflow:       'hidden',
    padding:        '10px 14px 0',
  },

  /* gridWrapper fills body, leaves space for footer */
  gridWrapper: {
    flex:           1,
    display:        'flex',
    flexDirection:  'column',
    overflow:       'hidden',
    paddingBottom:  60,           // space for absolute footer
    position:       'relative',
  },
  infoBar: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-between',
    background:     '#F8FAFC',
    border:         '1px solid #E2E8F0',
    borderRadius:   7,
    padding:        '6px 12px',
    marginBottom:   8,
    flexShrink:     0,
    gap:            12,
    display:        'none'
  },
  infoText: { color: '#475569', fontSize: 11, textTransform: 'uppercase',display:'none' },
  rowBadge: {
    background:     '#EFF6FF',
    border:         '1px solid #BFDBFE',
    color:          '#1D4ED8',
    fontSize:       11,
    fontWeight:     700,
    padding:        '2px 10px',
    borderRadius:   20,
    whiteSpace:     'nowrap',
    textTransform:  'uppercase',
    display:        'none'
  },

  gridContainer: {
    flex:     1,
    overflow: 'auto',
  },

  /* Bug 1 — footer absolute at bottom, load btn centered */
  footer: {
    position:       'absolute',
    bottom:         0,
    left:           0,
    right:          0,
    height:         52,
    background:     '#fff',
    borderTop:      '1px solid #E2E8F0',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'FLEX-END',   // centered
  },
  loadBtn: {
    display:        'flex',
    alignItems:     'center',
    gap:            7,
    padding:        '8px ',
    background:     '#16A34A',
    color:          '#fff',
    border:         'none',
    borderRadius:   7,
    fontWeight:     700,
    fontSize:       11,
    cursor:         'pointer',
    letterSpacing:  0.3,
    textTransform:  'uppercase',
    whiteSpace:     'nowrap',
  },

  loadingBox: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    gap:            12,
    padding:        '80px 20px',
  },
  spinner: {
    display:        'inline-block',
    width:          18,
    height:         18,
    border:         '2.5px solid rgba(37,99,235,0.20)',
    borderTopColor: '#2563EB',
    borderRadius:   '50%',
    animation:      'spin 0.75s linear infinite',
  },
  loadingText: {
    color:          '#64748B',
    fontSize:       16,
    fontWeight:     500,
    textTransform:  'uppercase',
  },
};

export default ProductStockDialog;